module.exports = __webpack_public_path__ + "img/SPA-img-03.eb0ddae3.jpg";